import { BASE_URL } from 'constants/api';

import actions from './index';
import { stringify } from 'query-string';
import { createGetAPI, createPostAPI } from '@cuemath/rest-api';

export const ACTIONS = {
  GET: 'CUEMATH_FEST_REPORTS_GET',
  GET_SUCCESS: 'CUEMATH_FEST_REPORTS_GET_SUCCESS',
  GET_FAILURE: 'CUEMATH_FEST_REPORTS_GET_FAILURE',
  POST: 'CUEMATH_FEST_REPORTS_POST',
  POST_SUCCESS: 'CUEMATH_FEST_REPORTS_POST_SUCCESS',
  POST_FAILURE: 'CUEMATH_FEST_REPORTS_POST_FAILURE',
};

const { useGet: useGetFestReport, invalidate } = createGetAPI({
  getURL: (_, query) => `${BASE_URL}/btl-events/?${stringify(query)}`,
});

const { usePost: usePostGroupReport } = createPostAPI({
  getURL: (_, { groupReportId }) => `${BASE_URL}/btl-events/${groupReportId}/send-comms/`,
});

export const post = actions.post(
  () => `${BASE_URL}/btl-events/report-upload/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
  {
    headers: {
      encType: 'multipart/form-data',
    },
  },
  true,
);

export { useGetFestReport, invalidate, usePostGroupReport };
